export const BASE_HELP_OPTIONS = [
    "My order hasn't arrived",
    'An item arrived damaged',
    'An item is different from what I ordered',
    'I need to change or update my order',
] as const;

export const HELP_OPTIONS = [...BASE_HELP_OPTIONS, 'Something else'] as const;

export const MAX_DETAILS_LENGTH = 500;

export const TWENTY_FOUR_HOURS_MS = 24 * 60 * 60 * 1000;
